import React, { Component } from 'react';
import style from '../../style/style';

class Noise extends Component {

  quantizeRate = () => {
    switch (this.props.data.properties.level) {
      case 75: return "red";
      case 70: return "orange";
      case 65: return "orange";
      case 60: return "#f1c40f";
      case 55: return "#73E8B0";
    }
  }

  render() {

    const colour = this.quantizeRate();

    return (
      <div 
        style={{ 
          ...style.fact.layout,
          alignItems: "center"
         }}
      > 
        <div style={{ ...style.fact.left, height: style.fact.left.width, display: "block" }}>
          <div
            style={{
              height: style.fact.left.width,
              width: style.fact.left.width,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "auto",
              position: "relative"
            }}
          >
            <div
              style={{
                height: "100%",
                width: "100%",
                background: colour,
                opacity: 0.2,
                borderRadius: "50%",
                position: "absolute"
              }}
            />
            <div
              style={{
                height: "80%",
                width: "80%",
                background: colour,
                opacity: 0.4,
                borderRadius: "50%",
                position: "absolute"
              }}
            />
            <div
              style={{
                height: "60%",
                width: "60%",
                background: colour,
                opacity: 0.6,
                borderRadius: "50%",
                position: "absolute"
              }}
            />
            <div
              style={{
                height: "40%",
                width: "40%",
                background: colour,
                opacity: 1,
                borderRadius: "50%",
                position: "absolute"
              }}
            />
          </div>
        </div>
        <div style={{ ...style.fact.right }}>
          <h2 style={{ 
            ...style.fact.heading,
            marginTop: "1rem",
            marginBottom: 0
            }}>
            {(() => {
                switch (this.props.data.properties.level) {
                  case 75: return "Undesirable";
                  case 70: return "Satisfactory";
                  case 65: return "Satisfactory";
                  case 60: return "Satisfactory";
                  case 55: return "Desirable";

                }
            })()} noise levels
          </h2>
          <p style={{ marginTop: 0, marginBottom: 0 }}>
            { `${this.props.data.properties.level-5}-${this.props.data.properties.level}db traffic noise levels` }
          </p>
          <div style={{ ...style.fact.source }}>Source: Noise maps 2012, <a href="https://data.gov.ie/dataset/noise-maps-from-traffic-sources-in-dublin-city-council">data.gov.ie</a>.</div>

        </div>
      </div>
    );
  }
}

export default Noise;



// WEBPACK FOOTER //
// ./src/components/noise/index.js